import { render, staticRenderFns } from "./acoustoSpectaculars.vue?vue&type=template&id=2f17fcec&scoped=true&"
import script from "./acoustoSpectaculars.vue?vue&type=script&lang=js&"
export * from "./acoustoSpectaculars.vue?vue&type=script&lang=js&"
import style0 from "./acoustoSpectaculars.vue?vue&type=style&index=0&id=2f17fcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17fcec",
  null
  
)

export default component.exports